/* eslint-disable react-hooks/exhaustive-deps */

import { useNavigate, useLocation } from "react-router-dom";
import { Box, Button, Text, NavLink, Modal } from "@/ui";
import { ReactComponent as SVGAccueil } from "../../images/accueil.svg";
import { ReactComponent as SVGGestion } from "../../images/gestion-cofidoc.svg";
import qs from "query-string";
import { useTheme } from "@mui/material";
import { setAccessToken, setIdToken, setRefreshToken } from "@/utils/localStorage";
import HandymanIcon from "@mui/icons-material/Handyman";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useMongoContext } from "@/provider/common/MongoProvider";
import { PraticienSelector } from "@/components/common/PraticienSelector";

export function LeftNavBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const [expandTools, setExpandTools] = useState(true);

  const navigationAccount = () => {
    const period = new Date(new Date().setDate(new Date().getDate()));
    period.setHours(0, 0);
    let to = qs.stringify({ period: period.getTime() }, { arrayFormat: "index" });
    navigate(`/account?${to}`);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      width="170px"
      height="100%"
      zIndex={100}
      className="overBg"
      justifyContent="space-between"
      alignItems="center"
      p={3}
      pt="20px"
      pb="20px"
    >
      <Box display="flex" flexDirection="column" alignItems="center" width="100%">
        <div className="logo-cofidoc" />
        <Box width="100%" p={1}>
          <PraticienSelector variant="compact" />
        </Box>
        <Box height="1px" width="100%" bgcolor="#d5d5d5" />
        <NavLink onClick={() => navigate("/home")} selected={location.pathname.includes("home")}>
          <SVGAccueil
            style={{
              width: "25px",
              height: "25px",
              color: location.pathname.includes("home") ? theme.palette.primary.main : "#6a6a6a",
            }}
          />
          <Box pr={1} />
          <Text m={0}>Accueil</Text>
        </NavLink>
        <Box height="1px" width="100%" bgcolor="#d5d5d5" />
        <NavLink onClick={navigationAccount} selected={location.pathname.includes("account")}>
          <SVGGestion
            style={{
              width: "25px",
              height: "25px",
              color: location.pathname.includes("account") ? theme.palette.primary.main : "#6a6a6a",
            }}
          />
          <Box p={1} />
          <Text m={0}>Gestion Cofidoc</Text>
        </NavLink>
        <Box height="1px" width="100%" bgcolor="#d5d5d5" />
        <NavLink selected={location.pathname.includes("tools")}>
          <Box
            onClick={() => setExpandTools(!expandTools)}
            position="absolute"
            right={-5}
            top={50}
            style={{
              color: theme.palette.primary.main,
              transform: expandTools ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform ease 300ms",
            }}
          >
            <ExpandMoreIcon />
          </Box>
          <Box flexDirection="column" justifyContent="center" alignItems="center" height="90px" onClick={() => setExpandTools(!expandTools)}>
            <Box flexDirection="column" justifyContent="center" alignItems="center">
              <HandymanIcon
                style={{
                  width: "25px",
                  height: "25px",
                  color: location.pathname.includes("tools") ? theme.palette.primary.main : "#6a6a6a",
                }}
              />
              <Box p={1} />
              <Text m={0}>Outils Cofidoc</Text>
            </Box>
          </Box>
          <Box
            flexDirection="column"
            alignItems="flex-end"
            height={expandTools ? "60px" : "0px"}
            style={{ transition: "height ease 300ms" }}
            overflow="hidden"
            width="100%"
          >
            <Box width="100%" height="30px" minHeight="30px" pl={3} justifyContent="flex-end" onClick={() => navigate("/tools/taxi")}>
              <Text
                textAlign="right"
                fontSize="13px"
                fontWeight={location.pathname.includes("tools/taxi") ? "700" : "400"}
                color={location.pathname.includes("tools/taxi") ? theme.palette.primary.main : ""}
                style={{ transition: "all ease 100ms" }}
              >
                Cofidoc Taxi
              </Text>
            </Box>
          </Box>
        </NavLink>
        <Box height="1px" width="100%" bgcolor="#d5d5d5" />
      </Box>
      <Profile />
    </Box>
  );
}

function Profile() {
  const { app }: any = useMongoContext();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const [openModal, setOpenModal] = useState(false);
  const navigationProfile = () => {
    const period = new Date(new Date().setDate(new Date().getDate()));
    period.setHours(0, 0);
    let to = qs.stringify({ period: period.getTime() }, { arrayFormat: "index" });
    navigate(`/profile?${to}`);
  };

  return (
    <Box justifyContent="center" alignItems="center" flexDirection="column">
      <Box justifyContent="center" alignItems="center" pb={4} onClick={navigationProfile} style={{ cursor: "pointer" }}>
        <Text
          textAlign="center"
          fontSize="12px"
          fontWeight={location.pathname.includes("profile") ? "700" : "400"}
          color={location.pathname.includes("profile") ? theme.palette.primary.main : ""}
        >
          Mes informations
        </Text>
      </Box>
      <Box justifyContent="center" alignItems="center" pb={4} style={{ cursor: "pointer" }}>
        <Text textAlign="center" fontSize="12px" onClick={() => setOpenModal(true)}>
          Contacter mon agence
        </Text>
        <RenderModal onClose={() => setOpenModal(false)} open={openModal} />
      </Box>
      <Button
        onClick={async () => {
          await app?.currentUser?.logOut();
          navigate("/welcome");
          setIdToken("");
          setAccessToken("");
          setRefreshToken("");
        }}
      >
        Déconnexion
      </Button>
    </Box>
  );
}

const RenderModal = ({ open, onClose }: { open: boolean; onClose: any }) => {
  const theme = useTheme();
  return (
    <Modal open={open} onClose={onClose}>
      <Box width="850px" maxWidth="98%" mx="auto" my={5} flexDirection="row" height="100%" alignItems="center">
        <Box width="50%" flexDirection="column" p={3}>
          <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
            <Text
              style={{
                fontSize: 30,
                fontWeight: 500,
                color: theme.colors.primary,
                textAlign: "center",
              }}
            >
              Besoin de renseignements ?
            </Text>
            <Box p={2} />
            <Text color={theme.palette.grey[500]} fontSize={12} fontWeight="700" textAlign="center">
              Contactez votre agence Cofidoc la plus la plus proche.
            </Text>
            <Box p={2} />

            <Text textAlign="center" mt={2}>
              <a href="tel:0806080808" style={{ color: theme.colors.primary }}>
                08 06 08 08 08
              </a>
            </Text>
          </Box>
        </Box>
        <Box width="50%" height="250px">
          <div className="image-cofidoc-metier" />
        </Box>
        <Box
          onClick={onClose}
          style={{
            cursor: "pointer",
            position: "absolute",
            bottom: 15,
            right: 30,
          }}
        >
          <Text color={theme.palette.primary.main} textAlign="center" fontWeight="700">
            FERMER
          </Text>
        </Box>
      </Box>
    </Modal>
  );
};
